const EXPONENT = 3;
const STEEPNESS = 3;

export function getStateValue(sliderValue, min, max) {
	const scaled = 1 + (STEEPNESS - 1) * parseFloat(sliderValue),
		norm =
			(Math.pow(scaled, EXPONENT) - 1) / (Math.pow(STEEPNESS, EXPONENT) - 1);
	return Math.min(max, Math.max(min, min + (max - min) * norm));
}

export function getSliderValue(stateValue, min, max) {
	const norm = (stateValue - min) / (max - min);
	const scaled = (Math.pow(STEEPNESS, EXPONENT) - 1) * norm + 1;

	return (Math.pow(scaled, 1 / EXPONENT) - 1) / (STEEPNESS - 1);
}

export function getHistogramClass(classes, stateValue, min, max) {
	return Math.min(
		classes - 1,
		Math.floor(classes * getSliderValue(stateValue, min, max)),
	);
}
